import { query, request } from 'src/utils/request';
import axios from 'axios';
import ZlbConfirm from '@/components/ZlbConfirm';

const urls = {
  list: '/zlb/api/pay/cashierSettlement/page', // 出纳列表
  // treasuryBatch: '/zlb/api/pay/cashierSettlement/treasury/batch', // 批量申请国库支付
  // markPayBatch: '/zlb/api/pay/cashierSettlement/markPaid/batch', // 批量标记已支付
  // reviewBatch: '/zlb/api/pay/cashierSettlement/review/batch', // 批量复核
  batchExport: '/zlb/api/pay/cashierSettlement/page/export', // 批量导出
  detail: '/zlb/api/pay/cashierSettlement/detail', // 结算详情
  timeLine: '/zlb/api/pay/cashierSettlement/operationLog', // 流转日志
  // comments: '/zlb/api/pay/cashierSettlement/comments', // 评论
  // print: '/zlb/api/pay/cashierSettlement/print', // 打印
  // review: '/zlb/api/pay/cashierSettlement/review', // 单据复核
  // treasury: '/zlb/api/pay/cashierSettlement/treasury', // 申请国库支付
  // markPaid: '/zlb/api/pay/cashierSettlement/markPaid', // 标记已支付
  // reject: '/zlb/api/pay/cashierSettlement/rejectToNode', // 驳回
  // payBatchNo: '/zlb/api/pay/cashierSettlement/apply/PayBatchNo', // 生成批次号
};

export async function reqList (data) {
  return request(urls.list, { method: 'POST', data });
}

export async function reqDetail (data) {
  return request(`${urls.detail}?payTradeNo=${data.payTradeNo}&status=${data.status}`, { method: 'POST' });
}

export async function reqBatchExport (data) {
  exportData(urls.batchExport, data);
}

export async function reqTimeLine (params) {
  return request(urls.timeLine + '/' + params.id, {
    params,
  });
}

// 报销单出纳结算列表筛选查询
export async function claimSearch (data) {
  return query('/zlb/api/expense/expense-form/cashier', { method: 'POST', data });
}

// 报销单出纳结算列表-同步支付结果
export async function syncPaymentResults (data) {
  return request('/zlb/api/pay/finance/synPayResult', { method: 'POST', data });
}

// 运营侧-单据查询-同步支付结果
export async function syncPaymentResultsForSearch (data) {
  return request('/zlb/api/pay/finance/syn-pay-result', { method: 'POST', data });
}

// 驳回报销单
export async function rejectExpenseForm (data) {
  return query('/zlb/api/expense/expense-form/reject', { method: 'POST', data });
}
// 更新报销单预算信息
export async function updateExpenseFormBudget (data) {
  return query('/zlb/api/expense/expense-form/updateExpenseFormBudget', { method: 'POST', data });
}
// 查询报销单详情
export function getClaimInfo (params) {
  return query(`/zlb/api/expense/expense-form/getInfoOnCashier?expenseFormCode=${params}&referer=web`);
}
// 查询报销单详情
export function getClaimDetail (params) {
  return query('/zlb/api/expense/expense-form/getInfoOnCashier', { params });
}

// 预算列表
export function getBudgetList (data) {
  return query('/zlb/api/expense/budget/query-budget', { method: 'POST', data });
}

// 获取支付渠道和支付类型
export function getPayModeEnum (data) {
  return query('/zlb/api/expense/expense-form/getPayModeEnum', { method: 'GET', data });
}

function exportData (url, cdata) {
  axios
    .request({
      url,
      method: 'POST',
      data: cdata,
      responseType: 'blob',
    })
    .then((res) => {
      const { data, headers } = res;
      const blob = new Blob([data], { type: headers['content-type'] });
      const fileName = decodeURI(
        headers['content-disposition'].replace(/\w+;filename=(.*)/, '$1')
      );
      if ('download' in document.createElement('a')) {
        // 非IE下载
        const elink = document.createElement('a');
        elink.download = fileName;
        elink.style.display = 'none';
        elink.href = URL.createObjectURL(blob);
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(elink.href); // 释放URL 对象
        document.body.removeChild(elink);
      } else {
        // IE10+下载
        navigator.msSaveBlob(blob, fileName);
      }
      ZlbConfirm({
        title: '数据导出成功',
        content: `您所选中的数据已成功导出至本地，文件名：${fileName}`,
        showOkBtn: false,
        cancelText: '知道了',
      });
    })
    .catch((err) => {
      const { message } = err;
      if (message !== 'Operation canceled by the user.') {
        ZlbConfirm({
          title: '数据导出失败',
          content: '您所选中的数据未能成功导出,请您稍后重试',
          showOkBtn: false,
          cancelText: '知道了',
        });
      }
    });
}
